import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Switch, IconButton, Tooltip } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getAllClients, toggleClient } from "../../../redux/actions/authActions";
import SearchBar from "../../../components/searchbar/SearchBar";

const ClientManagementDatatable = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [rows, setRows] = useState([]);
  const [allClients, setAllClients] = useState([]);
  const clients = useSelector((state) => state.auth.allClients);
  const token = localStorage.getItem("token");

  useEffect(() => {

    const fetchData = async () => {
      if (token) {
        await dispatch(getAllClients(token));
      }
    };
    try {
      fetchData();
    }
    catch (err) {
      console.log(err);
    }
  
  }, [token, dispatch]);

  useEffect(() => {
    if (clients && Array.isArray(clients)) {
      setRows(clients);
      setAllClients(clients);
    }
  }, [clients]);

  const handleSearch = (searchTerm) => {
    if (!searchTerm || searchTerm.trim() === "") {
      setRows(allClients);
      return;
    }
    const filtered = allClients.filter((client) =>
      client?.name?.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setRows(filtered);
  };

  const handleToggleStatus = async (id, newStatus) => {
    try {
      await dispatch(toggleClient(id, newStatus));
      setRows((prev) =>
        prev.map((row) =>
          row._id === id ? { ...row, accountStatus: newStatus } : row
        )
      );
      setAllClients((prev) =>
        prev.map((row) =>
          row._id === id ? { ...row, accountStatus: newStatus } : row
        )
      );
    } catch (err) {
      console.error(err);
    }
  };

  const handleView = (id) => {
    navigate(`view-client/${id}`);
  };

  const columns = [
    { field: "id", headerName: "Client ID", width: 120 },
    {
      field: "createdAt",
      headerName: "Created on",
      width: 160,
      renderCell: (params) =>
        params.value ? new Date(params.value).toDateString() : "N/A",
    },
    { field: "businessName", headerName: "Client Name", width: 180 },
    { field: "email", headerName: "Email Address", width: 220 },
    { field: "clientType", headerName: "Client Type", width: 150 },
    // {
    //   field: "defaultPassword",
    //   headerName: "Default Password",
    //   width: 170,
    //   renderCell: (params) => (
    //     <DefaultPasswordCell
    //       name={params.row.name || params.row.businessName}
    //       phoneNumber={params.row.phoneNumber}
    //     />
    //   ),
    // },

    {
      field: "services",
      headerName: "Service Taken",
      width: 220,
      renderCell: (params) =>
        Array.isArray(params.value)
          ? params.value.map((s) => s.name).join(", ")
          : "----",
    },
    {
      field: "accountStatus",
      headerName: "Account Status",
      width: 150,
      renderCell: (params) => {
        const isActive = params.value !== false;
        return (
          <Tooltip title={isActive ? "Active (Click to Deactivate)" : "Deactivated (Click to Activate)"}>
            <Switch
              checked={isActive}
              onChange={() => handleToggleStatus(params.row._id, !isActive)}
              color="success"
            />
          </Tooltip>
        );
      },
    },
    {
      field: "manage",
      headerName: "Manage",
      width: 100,
      renderCell: (params) => (
        <Tooltip title="View Details">
          <IconButton
            onClick={() => handleView(params?.row?._id)}
            color="primary"
            size="small"
          >
            <VisibilityIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      ),
    },
  ];

  return (
    <>
      {/* Search Bar stays outside the table card */}
      <SearchBar
        titleOne="Add Client"
        onSearch={handleSearch}
        addClientPath="/client-management/add-client"
        showAddButton={true}
      />

      {/* Table with border & shadow for consistency */}
      <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-6">
        <div className="h-[500px]">
          <DataGrid
            rows={rows}
            columns={columns}
            getRowId={(row) => row._id || row.id}
            pageSizeOptions={[5, 8, 10, 25]}
            initialState={{
              pagination: { paginationModel: { pageSize: 8, page: 0 } },
            }}
            pagination
            sx={{
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#f9fafb",
                fontWeight: "bold",
                fontSize: "0.875rem",
              },
              "& .MuiDataGrid-cell": {
                fontSize: "0.875rem",
              },
              "& .MuiDataGrid-row:hover": {
                backgroundColor: "#f3f4f6",
              },
              border: "none", // remove internal grid border, rely on outer container border
            }}
          />
        </div>
      </div>
    </>
  );
};

export default ClientManagementDatatable;
